import { GetQueryString, RemoveQueryString, AddQueryString, siteIsUseCookie } from './common';

export function getCookie(name) {
	if (!siteIsUseCookie) {
		const para = GetQueryString(name);
		console.log(name + "=" + para);
		return para == "" ? null : para;
	} else {
		var start = document.cookie.indexOf(name + '=');
		var len = start + name.length + 1;
		if (!start && name != document.cookie.substring(0, name.length)) {
			return null;
		}

		if (start == -1) return null;
		var end = document.cookie.indexOf(';', len);
		if (end == -1) end = document.cookie.length;
		return unescape(document.cookie.substring(len, end));
	}
}

export function setCookie(name, value, expires, path, domain) {
	if (!siteIsUseCookie) {
		const para = AddQueryString(name + "=" + value, RemoveQueryString(name));
		window.history.pushState('','','?'+para);
	} else {
		var today = new Date();
		today.setTime(today.getTime());
		if (expires) {
			expires = expires * 1000 * 60 * 60 * 24;
		}

		var secure = window.location.protocol == "https:";
		var expires_date = new Date(today.getTime() + expires);
		document.cookie =
			name +
			'=' +
			escape(value) +
			(expires ? ';expires=' + expires_date.toGMTString() : '') + //expires.toGMTString()
			(path ? ';path=' + path : '') +
			(domain ? ';domain=' + domain : '') +
			(secure ? ';secure;SameSite=None' : '');
	}
}

export function deleteCookie(name, path, domain) {
	if (!siteIsUseCookie) {
		const para = RemoveQueryString(name);
		window.history.pushState('','','?'+para);
	} else {
		if (getCookie(name))
			document.cookie =
				name +
				'=' +
				(path ? ';path=' + path : '') +
				(domain ? ';domain=' + domain : '') +
				';expires=Thu, 01-Jan-1970 00:00:01 GMT';
	}
}
